module.exports = __webpack_public_path__ + "img/icon_map_62_on_111.712ac992.png";